const _stipulator_contract_context = Symbol('_stipulator_contract_context');

enum IeTipoEstipulante {
  PJ = 'PJ',
  PF = 'PF',
}

enum Entry {
  ALLOWED = 'S',
  DENIED = 'N',
  T = 'T',
}

interface Contract {
  nrSeqContrato: number;
  nrContrato: number;
  nrSeqSubestipulante: number;
  ieOrigemGrupoWeb: number;
  cdEstipulante: string;
  dsEstipulante: string;
  nmSubestipulante: string;
  ieTipoEstipulante: IeTipoEstipulante;
  dtContrato: string;
  qtdSubestipulantes: number;
}

interface TwsFunction {
  nrSequencia: number;
  cdFuncao: number;
  dsFuncao: string;
  vlParametro: Entry;
}

interface ContractContext {
  current: Contract;
  contracts: Contract[];
  allowedTwsFunctions: TwsFunction[];
}

class StipulatorGlobalContext {

  [_stipulator_contract_context]: ContractContext;

  init(contracts: Contract[], allowedTwsFunctions: TwsFunction[]): void {
    if (!contracts) {
      return;
    }

    const [current] = contracts;

    this[_stipulator_contract_context] = {
      current,
      contracts,
      allowedTwsFunctions,
    };
  }

  isInitiated(): boolean {
    return Boolean(this[_stipulator_contract_context]);
  }

  getCurrentContract(): Contract {
    return this[_stipulator_contract_context]?.current;
  }

  getContracts(): Contract[] {
    return this[_stipulator_contract_context].contracts;
  }

  getAllowedTwsFunctions(): TwsFunction[] {
    return this[_stipulator_contract_context].allowedTwsFunctions;
  }

  setCurrentContract(nrSeqContrato: number): void {
    const newCurrent = this.getContracts().find(contract => contract.nrSeqContrato === nrSeqContrato);

    if (!newCurrent) {
      return;
    }

    this[_stipulator_contract_context] = {
      ...this[_stipulator_contract_context],
      current: newCurrent,
    };
  }

  isAllowedTwsFunction(name: string, value: Entry = Entry.ALLOWED): boolean {
    return Boolean(this.getAllowedTwsFunctions().find(twsFunction => twsFunction.dsFuncao === name && twsFunction.vlParametro === value));
  }
}

const StipulatorContext = new StipulatorGlobalContext();

export {
  StipulatorContext as default,
  Contract,
  TwsFunction,
  IeTipoEstipulante,
  Entry,
};
